import React, { useState, useEffect, useReducer } from 'react';
import api from '../FetchComponents/FetchComponentsServices';
import AdminModal from './AdminModal';
import DeleteAdminModal from './DeleteAdminModal';
import "../Shared/AdminPage.css"

const AdminPage = () => {
  const [loading, setLoading] = useState(true);
  const [selectedAdmin, setSelectedAdmin] = useState({ userName: '' });
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userNames, setUserNames] = useState([]);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState('');
  function fetchDataReducer(state, action) {
    switch (action.type) {
      case "Load":
        setLoading(false);
        return action.data;
      case "Select":
        return state;
      default:
        return state;
    }
  }

  const [admins, dispatch] = useReducer(fetchDataReducer);
  useEffect(() => FetchAdmins(), []);

  const FetchAdmins = () => {
    api.getDashboardAdmins()
      .then(data => {
        dispatch({ type: "Load", data: data });
        let userNames = []
        data.map((admin) => userNames.push(admin.userName))
        setUserNames(userNames)
      })
        .catch(error => {
            setMessage(error.message);
            setError(true);
            setLoading(false);
            console.log(error) // todo add better logging / error handing
      })
  }

  const onAdd = () => {
    setSelectedAdmin({})
    setShowModal(true)
  }

  const OnEdit = (admin) => {
    setSelectedAdmin(admin)
    setShowModal(true)
  }

  const OnDelete = (admin) => {
    setSelectedAdmin(admin)
    setShowDeleteModal(true)
  }

  const DeleteAdmin = async () => {
    try {
      await api.deleteDashboardAdmin(selectedAdmin.id)
      setShowDeleteModal(false)
      FetchAdmins()
    } catch (error) {
      // Handle error
      console.error('Error deleting new Admin:', error.message);
    }
  }

  const UserNameExists = (userName) => {
    return userNames.includes(userName)
  }

  const IsOwnUserName = (admin) => {
    const matchingUser = admins.find(x => x.id === admin.id)
    if(matchingUser) {
      return matchingUser.userName === admin.userName
    } else {
      return false
    }
  }

  const renderAdminRow = (admin, index) => {
    const even = (index % 2 == 0)
    return <tr key={admin.id} className={even ? 'even' : 'odd'}>
      <td>{admin.userName}</td>
      <td>{admin.firstName}</td>
      <td>{admin.lastName}</td>
      <td>{admin.role}</td>
      <td>{admin.isActive ? 'Yes' : 'No'}</td>
      <td className='btn-container'>
        <button onClick={() => OnEdit(admin)} aria-label={`Edit ${admin.userName}`} className='k-button-solid-secondary k-button-sm edit-btn'>Edit</button>
        <button onClick={() => OnDelete(admin)} aria-label={`Delete ${admin.userName}`} className='k-button-solid-primary k-button-sm delete-btn'>Delete</button>
      </td>
    </tr>
  }

  const renderAdminsTable = () => {
      return (
          <>
              <h1 className="page-title">Administrators</h1>

              {error && <h2>{message}</h2>}

              {!error && (
                  <>
                      <div className='add-admin-btn-container'>
                          <button
                              className='k-button-solid-secondary k-button-lg add-btn'
                              onClick={onAdd}
                          >
                              Add Admin
                          </button>
                      </div>

                      <table className='table-striped' aria-labelledby="tabelLabel">
                          <thead>
                              <tr className='odd'>
                                  <th>User Name (name.#)</th>
                                  <th>First Name</th>
                                  <th>Last Name</th>
                                  <th>Role</th>
                                  <th>Active</th>
                                  <th>Update</th>
                              </tr>
                          </thead>
                          <tbody>
                              {admins.map((admin, index) => renderAdminRow(admin, index))}
                          </tbody>
                      </table>

                      {showModal && (
                          <AdminModal
                              admin={selectedAdmin}
                              userNameExists={UserNameExists}
                              isOwnUserName={IsOwnUserName}
                              onClose={() => setShowModal(false)}
                              fetchAdmins={FetchAdmins}
                              SaveButtonText="Save Admin"
                          />
                      )}

                      {showDeleteModal && (
                          <DeleteAdminModal
                              admin={selectedAdmin}
                              onDelete={DeleteAdmin}
                              onCancel={() => setShowDeleteModal(false)}
                          />
                      )}
                  </>
              )}
          </>
      );

  }

  let contents = loading
    ? <p><em>Loading...</em></p>
    : renderAdminsTable();

  return (
    <>
      {contents}
    </>
  );
};

export default AdminPage;
